import { loadStripe } from '@stripe/stripe-js';

// Live Stripe publishable key for pay.earth (Account: acct_1RTLCW0715VRX90B)
export const LIVE_STRIPE_PUBLISHABLE_KEY =
  'pk_live_51RTLCW0715VRX90BL7e2FirH0PgxBqFRN6AxlPVmUN89vYYPMm7laT0vRoAzEsNpK9CK3yit1GZE4VRsf4JKJdy500SlpvmtKR';

export const getStripePublishableKey = () => {
  const envKey = (process.env.REACT_APP_PUBLISHABLE_KEY || '').trim();
  const allowTestKey = process.env.REACT_APP_USE_STRIPE_TEST === 'true';

  if (envKey) {
    if (allowTestKey || !envKey.startsWith('pk_test_')) {
      return envKey;
    }
  }
  return LIVE_STRIPE_PUBLISHABLE_KEY;
};

export const publishableKey = getStripePublishableKey();

export const stripePromise = publishableKey
  ? loadStripe(publishableKey)
  : Promise.resolve(null);

export default stripePromise;
